import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

import { Observable, Subscription } from 'rxjs';
import { LessonModel, TopicModel } from '@generativ/much-smarter-models';

import { LessonService } from '../../exercise/shared/lesson.service';
import { MultiChoiceComponent } from '../../exercise/shared/multi-choice/multi-choice.component';
import { UtilitiesService } from '../../../../shared/utilities.service';
import { ContentViewerComponent } from '../../../../shared/content-viewer/content-viewer.component';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { SpinnerComponent } from '../../../../shared/spinner/spinner.component';


@Component({
    selector: 'app-lesson-strategy-identification',
    templateUrl: './lesson-strategy-identification.component.html',
    styleUrls: ['./lesson-strategy-identification.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ContentViewerComponent, MultiChoiceComponent, NgTemplateOutlet, SpinnerComponent, RouterLink, AsyncPipe]
})
export class LessonStrategyIdentificationComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  lesson: Observable<LessonModel>;
  topics: Observable<TopicModel[]>;

  readyToContinue = false;

  @ViewChild(MultiChoiceComponent)
  private multiChoiceComponent: MultiChoiceComponent<TopicModel>;

  constructor(private activatedRoute: ActivatedRoute,
              private lessonService: LessonService,
              public utilitiesService: UtilitiesService) {
  }

  ngOnInit() {
    this.subscriptions.add(this.activatedRoute.params.subscribe((params) => {
      if (params['lessonId']) {
        this.lesson = this.lessonService.getLesson(params['lessonId']);
      }
      // Todo: Get a better way (here we're calling twice in das topic id and then in das strategy id)
      this.topics = this.lessonService.getTopics(params['lessonId']);
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  handleSelectedTopic(topic, lesson: LessonModel) {
    this.subscriptions.add(this.lessonService.identifyTopicForLesson(lesson.id, topic.id).subscribe(data => {
      this.readyToContinue = true;
      this.multiChoiceComponent.setRightOption(+data);
    }));
  }
}
